<template>
  <!--  -->
  <div class="wrapper">
    <admin-title :title="$route.meta.name"></admin-title>
    <el-form
        ref="form"
        inline
        :model="searchData"
        label-width=""
    >
      <el-form-item label="代理商" prop="agent_id">
        <select-channel type="lkl"  v-model="searchData.agent_id"></select-channel>
      </el-form-item>
      <el-form-item label="sn">
        <el-input
            style="width: 200px"
            clearable
            v-model="searchData.posSn"
            size="mini"
            placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label=" ">
        <el-button
            type="primary"
            size="mini"
            icon="el-icon-search"
            @click="getList"
        >搜索
        </el-button>
        <el-button
            type="info"
            size="mini"
            icon="el-icon-refresh"
            @click="reset"
        >重置
        </el-button>
      </el-form-item>
    </el-form>
<!--    <el-upload-->
<!--        class="upload-demo"-->
<!--        action=" "-->
<!--        :before-upload="beforeUpload"-->
<!--        :http-request="importTable"-->
<!--        :show-file-list="false"-->
<!--        accept=".xls,.xlsx"-->
<!--    >-->
<!--      <el-button-->
<!--          style="margin-bottom: 10px;margin-right: 10px;"-->
<!--          icon="el-icon-upload"-->
<!--          type="primary"-->
<!--          size="mini"-->
<!--          plain-->
<!--      >导入-->
<!--      </el-button>-->
<!--    </el-upload>-->
    <!-- list -->
    <el-table
        :data="list"
    >
      <el-table-column
          prop="source"
          label="来源"
          width="70"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.source == 1" type="success">API</el-tag>
          <el-tag v-else>EXCEL</el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="orgCode"
          label="机构编号"
      ></el-table-column>
      <el-table-column
          prop="agentNo"
          label="合作方编号"
      ></el-table-column>
      <el-table-column
          prop="externalCustomerNo"
          label="外部商户编号"
      ></el-table-column>
      <el-table-column
          prop="customerName"
          label="商户名称"
      ></el-table-column>
      <el-table-column
          prop="legalName"
          label="法人姓名"
      ></el-table-column>
      <el-table-column
          prop="posSn"
          label="sn"
      ></el-table-column>
      <el-table-column
          prop="posType"
          label="机具类型"
      ></el-table-column>
      <el-table-column
          prop="termNo"
          label="终端号"
      ></el-table-column>
      <el-table-column
          prop="operateTime"
          label="操作时间"
      ></el-table-column>
      <el-table-column
          prop="data_id"
          label="data_id"
      ></el-table-column>
    </el-table>
    <pagination
        :total="total"
        :page.sync="searchData.page"
        :limit.sync="searchData.page_size"
        @pagination="getList"
    />
    <importProgressBar v-if="isShowImport" :isShowImport="isShowImport" :import_task_id="import_task_id" @close="isShowImport = false"></importProgressBar>
  </div>
</template>

<script>
import {getPosBindPageAPI, importPosBindApi} from '../api'
import {authBtnMixin} from '@/mixins/authBtnMixin'
import importProgressBar from "@/components/import-progress-bar/index.vue";
import SelectChannel from "@/components/dict/select-channel.vue";


export default {
  name: 'Index',
  components: {SelectChannel, importProgressBar},
  mixins: [authBtnMixin],
  // components: { SelectRole, SelectAdminUser },
  data() {
    return {
      rules: [{required: true, message: '该项不能为空', trigger: 'blur'}],
      show_update: false,
      list: [],
      userList: [],
      searchData: {
        posSn: '',
        merchant_id: '',
        merchant_name: '',
        source: '',
        agent_id: '',
      },
      total: 0,
      detail: {},
      isShowImport: false,
      import_task_id: ''
    }
  },

  activated() {
  },
  mounted() {
    this.getList()
  },

  methods: {
    beforeUpload(file) {
      if (file.name.split('.').pop() !== 'xlsx' && file.name.split('.').pop() !== 'xls') {
        this.$message.error('请上传xlsx或xls格式文件!')
        return false
      }
    },
    importTable(file) {
      const fd = new FormData()
      fd.append('import_file', file.file)
      importPosBindApi(fd).then(res => {
        this.import_task_id = res.import_task_id
        this.isShowImport = true
      })
    },
    formatJson(json) {
      if (json && typeof json === 'object') {
        return JSON.stringify(json, null, 2); // 格式化 JSON 字符串
      }
      return json || '无数据';
    },
    async getList() {
      const res = await getPosBindPageAPI(this.searchData)
      this.list = res.data
      this.total = res.total
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData)
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  .ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  width: 100%;

  .inviter {
    display: inline-flex;
    align-items: center;
    background: #f8f8f9;
    border-radius: 5px;
    padding: 0 20px;

    .inviter-info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      .inviter-name {
        font-weight: 600;
      }
    }
  }

  .balance-box {
    display: flex;
    // align-items: center;
    .balance-item {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      background: #f5f5f5;
      border-radius: 5px;
      padding: 0 20px;
      margin-right: 20px;

      span {
        &:last-child {
          font-weight: 600;
        }
      }
    }
  }
}
</style>
